import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Calendar, MapPin, User, Mail, Clock, CheckCircle, School, Languages } from 'lucide-react';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import { uri } from "constants/common";

const InterpretingForm2 = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const numericStep = currentStep === "specialStep" ? 3 : (typeof currentStep === "number" ? currentStep : 1);
    const effectiveStep = currentStep === 8 ? 2 : currentStep;
    const [languages, setLanguages] = useState([]);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        // Step 1
        email: "",
        personName: "",
        location: "",
        // otherLocation: "",

        // Step 2
        meetingFormat: "",
        typeOfMeeting: "",
        otherMeetingType: "",

        // Step 3
        meetingDate: "",
        afterHoursStartTime: "",
        endsByFour: "",

        // Step 4
        afterHoursEndTime: "",
        meetingPhone: "",
        roomNumber: "",
        reportTo: "",
        additionalContact: "",
        additionalInfo: "",
        studentSpecific: "",

        // Step 5
        studentName: "",
        studentPermId: "",
        studentSchool: "",
        guardianName: "",
        guardianPhone: "",

        // Step 6
        languageOfService: "",
        dialect: "",
        additionalComments: ""
    });

    const [schools, setSchools] = useState([]);

    const steps = [
        { id: 1, title: '', icon: User },
        { id: 2, title: '', icon: Calendar },
        { id: 3, title: '', icon: Clock },
        { id: 4, title: '', icon: MapPin },
        { id: 5, title: '', icon: School },
        { id: 6, title: '', icon: CheckCircle },
    ];


    const [errors, setErrors] = useState({});
    const [showSpecialStep, setShowSpecialStep] = useState(false);
    const displayStepNumber = currentStep === "specialStep" ? 3 : effectiveStep;

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        setErrors(prev => ({ ...prev, [field]: "" }));
    };
    const meetingTypes = [
        'In Person',
        'Phone',
        'Online Video Call (Zoom, Google Meet, or GotoMeeting)',
    ];

    useEffect(() => {
        const fetchSchools = async () => {
            try {
                const response = await fetch(uri + '/get-schools');
                const data = await response.json();
                if (data.success) {
                    setSchools(data.data); // Update the schools list
                }
            } catch (error) {
                console.error('Error fetching schools:', error);
            }
        };

        fetchSchools();
    }, []);

    const typeofmetting = [
        'SST / 504',
        'Initial IEP / Annual IEP',
        'TriAnnual IEP',
        'Student Assessment',
        'Pre-Expulsion / SARB',
        'Expulsion Hearing',
        'Board Meeting',
        'Parent Meeting',
        'Conference call / Phone Appt.',
        'Other',
    ];

    useEffect(() => {
        const fetchLanguages = async () => {
            try {
                const response = await fetch(uri + '/get-languages');
                const data = await response.json();
                if (data.success) {
                    setLanguages(data.data); // Store the fetched language data
                }
            } catch (error) {
                console.error('Error fetching languages:', error);
            }
        };

        fetchLanguages();
    }, []);

    const validateStep = (step) => {
        const newErrors = {};

        switch (step) {
            case 1:
                if (!formData.email) newErrors.email = "Email is required";
                else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Must be a valid email";

                if (!formData.personName) newErrors.personName = "Your name is required";
                if (!formData.location) newErrors.location = "Location is required";
                // if (formData.location === "Other" && !formData.otherLocation) {
                //     newErrors.otherLocation = "Please specify the location";
                // }
                break;

            case 2:
                // ✅ Meeting Format Validation
                if (!formData.meetingFormat) newErrors.meetingFormat = 'Meeting format is required';

                // ✅ Type of Meeting Validation
                if (!formData.typeOfMeeting) {
                    newErrors.typeOfMeeting = "Type of meeting is required";
                } else if (formData.typeOfMeeting === "Other:" && !formData.otherMeetingType) {
                    newErrors.otherMeetingType = "Please specify the type of meeting";
                }
                break;

            case 3:
                if (!formData.meetingDate) newErrors.meetingDate = "Meeting date is required";
                if (!formData.afterHoursStartTime) newErrors.afterHoursStartTime = "Start time is required";
                break;
            case 4:
                if (!formData.afterHoursEndTime) newErrors.afterHoursEndTime = "End time is required";
                if (!formData.meetingPhone) newErrors.meetingPhone = "Meeting location phone number is required";
                else if (formData.meetingPhone.replace(/\D/g, '').length !== 10) newErrors.meetingPhone = "Phone number must be 10 digits (xxx-xxx-xxxx)";
                if (!formData.reportTo) newErrors.reportTo = "Please specify whom the interpreter should report to";
                if (!formData.studentSpecific) newErrors.studentSpecific = "Please select Yes or No";
                break;
            case 5:
                if (!formData.studentName) newErrors.studentName = "Student's name is required";
                if (!formData.studentPermId) newErrors.studentPermId = "Student's ID is required";
                if (!formData.studentSchool) newErrors.studentSchool = "School is required";
                if (!formData.guardianName) newErrors.guardianName = "Guardian's name is required";
                if (!formData.guardianPhone) newErrors.guardianPhone = "Guardian phone number is required";
                else if (formData.guardianPhone.replace(/\D/g, '').length !== 10) newErrors.guardianPhone = "Phone number must be 10 digits (xxx-xxx-xxxx)";
                break;

            case 6:
                if (!formData.languageOfService) {
                    newErrors.languageOfService = "Please select the language of service";
                }
                break;

            default:
                break;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleNext = () => {
        if (!validateStep(currentStep)) return;

        if (currentStep === 3 && formData.endsByFour === "Yes") {
            setCurrentStep("specialStep");
        } else if (currentStep === "specialStep") {
            // Special step ke baad form ko reset ya step 1 pe le jao
            setCurrentStep(1);
            setErrors({});
        } else if (currentStep === 4 && formData.studentSpecific === "No") {
            setCurrentStep(6);
        }else {
            setCurrentStep(prev => Math.min(prev + 1, steps.length));
        }
    };



    const handlePrevious = () => {
        if (currentStep === "specialStep") {
            // Agar special step pe hain to wapis step 3 pe bhejo
            setCurrentStep(3);
        } else if(currentStep === 6 && formData.studentSpecific === "No"){
            setCurrentStep(4);
        }else {
            setCurrentStep((prev) => Math.max(prev - 1, 1));
        }
    };

    const handleSubmit = async () => {
        if (!validateStep(6)) return;
        setLoading(true);
        try {
            const apiPayload = {
                type: 1,
                email: formData.email,
                contact_person_name: formData.personName,

                meeting_format: formData.meetingFormat,  // yahan array hai
                meeting_end_before_4pm: formData.endsByFour === "Yes",

                meeting_type: formData.typeOfMeeting,
                meeting_type_other: formData.otherMeetingType,

                meeting_date: formData.meetingDate,
                start_time: formData.afterHoursStartTime,
                end_time: formData.afterHoursEndTime,

                reporting_person: formData.reportTo,
                additional_contact_number: formData.additionalContact,
                specific_to_student: formData.studentSpecific === "Yes",
                other_related_information: formData.additionalInfo,

                student_name: formData.studentName,
                parent_name: formData.guardianName,
                parent_contact_number: formData.guardianPhone,

                language_id: formData.languageOfService,
                dialect: formData.dialect,
                school: formData.location,
                important_information: formData.additionalComments,
                // other_location: formData.otherLocation,

                // extra optional fields
                student_perm_id: formData.studentPermId,
                meeting_location_number: formData.meetingPhone,
                room_number_at_site: formData.roomNumber,
                school_student_attends: formData.studentSchool,
            };

            const response = await fetch(
                uri+"/interpreting-service-request/generate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(apiPayload),
                }
            );

            const result = await response.json();

            if (response.ok) {
                setLoading(false);
                Swal.fire({
                    title: "Success!",
                    text: 'Appointment created successfully. Your Appointment ID is #' + result.message,
                    icon: "success",
                    confirmButtonText: "OK",
                }).then(() => {
                    setFormData({
                        // Step 1
                        email: "",
                        personName: "",
                        location: "",
                        // otherLocation: "",

                        // Step 2
                        meetingFormat: "",
                        typeOfMeeting: "",
                        otherMeetingType: "",

                        // Step 3
                        meetingDate: "",
                        afterHoursStartTime: "",
                        endsByFour: "",

                        // Step 4
                        afterHoursEndTime: "",
                        meetingPhone: "",
                        roomNumber: "",
                        reportTo: "",
                        additionalContact: "",
                        additionalInfo: "",
                        studentSpecific: "",

                        // Step 5
                        studentName: "",
                        studentPermId: "",
                        studentSchool: "",
                        guardianName: "",
                        guardianPhone: "",

                        // Step 6
                        languageOfService: "",
                        dialect: "",
                        additionalComments: ""
                    });
                    setCurrentStep(1);
                });
                console.log("API Response:", result);
            } else {
                setLoading(false);
                const errorMessages = result?.errors
                    ? Object.values(result.errors).flat().join('\n')
                    : null;
                Swal.fire({
                    title: "Error!",
                    text: errorMessages || result?.message || "Submission failed. Please try again.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: "Network Error",
                text: "There was a network error. Please try again later.",
                icon: "error",
                confirmButtonText: "OK",
            });
            console.error("Error submitting form:", error);
        }
    };

    console.log('formdata', formData);

    const renderStepContent = () => {
        switch (currentStep) {

            case 1:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Interpreter Requests for Evening School Events (after 4 pm meetings/events) </h2>
                            <p className="step-description">Please complete this form to request an interpreter if the event is beyond the school day (after 4:00 pm) from <strong>the Language Development Office </strong>.
                                <br />
                                <br />
                                To schedule an interpreter, please submit the form at least ten days <strong>(10 working days) prior</strong> to the date of the meeting.  Please submit your request as quickly as possible as we schedule on a first come, first served basis.
                                <br />
                                PROCEDURES TO CANCEL AND RESCHEDULE INTERPRETER SERVICES
                                To cancel and reschedule, please contact: the Language Development Office  and provide the information that was submitted on the service request form.  Last minute cancellations: <strong>Please contact us 24 hours in advance if the meeting has been canceled.</strong>
                                <br />
                                <br />
                                Language Development Office
                                <br />
                                56 S.  Lincoln Street Stockton, Ca 95203
                                <br />
                                Phone: (209) 933‐7074
                                <br />
                                <br />
                                 <span className='required'>* Indicates required question</span>
                            </p>
                        </div>

                        {/* Email Field */}
                        <div className="form-group">
                            <label className="form-label">
                                Email <span className="required">*</span>
                            </label>
                            <input
                                type="email"
                                value={formData.email || ""}
                                onChange={(e) => handleInputChange("email", e.target.value)}
                                className={`form-input ${errors.email ? "error" : ""}`}
                                placeholder="Enter your email"
                            />
                            {errors.email && <p className="error-message">{errors.email}</p>}
                        </div>

                        {/* Full Name Field */}
                        <div className="form-group">
                            <label className="form-label">
                                Complete Name of Person Completing Form ( your name) <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.personName || ""}
                                onChange={(e) => handleInputChange("personName", e.target.value)}
                                className={`form-input ${errors.personName ? "error" : ""}`}
                                placeholder="Enter your full name"
                            />
                            {errors.personName && <p className="error-message">{errors.personName}</p>}
                        </div>

                        {/* Site / Department / Location Dropdown */}
                        <div className="form-group">
                            <label className="form-label">
                                Site / Department / Location (of person completing request)
                                <span className="required">*</span>
                            </label>

                            <select
                                value={formData.location || ""}
                                onChange={(e) => handleInputChange("location", e.target.value)}
                                className={`form-input ${errors.location ? "error" : ""}`}
                            >
                                <option value="">Select a Location</option>
                                {schools.map((school) => (
                                    <option key={school.id} value={school.id}>
                                        {school.name}
                                    </option>
                                ))}
                                {/* <option value="Other">other</option> */}
                            </select>
                            {errors.location && <p className="error-message">{errors.location}</p>}

                            {/* {formData.location === "Other" && (
                                <div className="form-group" style={{ marginTop: '1rem' }}>
                                <label className="form-label">
                                Please specify <span className="required">*</span>
                                    </label>
                                    <input
                                    type="text"
                                    value={formData.otherLocation || ""}
                                    onChange={(e) => handleInputChange("otherLocation", e.target.value)}
                                    className={`form-input ${errors.otherLocation ? "error" : ""}`}
                                    placeholder="Enter custom location"
                                    />
                                    {errors.otherLocation && (
                                        <p className="error-message">{errors.otherLocation}</p>
                                        )}
                                        </div>
                                        )} */}
                        </div>

                    </div>
                );

            case 2:
                return (
                    <div className="step-content">
                        {/* Step Header */}
                        <div className="step-header">
                            <h2 className="step-title">Meeting Format and Type</h2>
                            <p className="step-description">Select how the meeting will be conducted and specify the type of meeting.</p>

                        </div>

                        {/* Format for Meeting Label */}
                        <div className="form-group">
                            <label className="form-label">
                                Format for Meeting<span className="required">*</span>
                            </label>
                            <select
                                value={formData.meetingFormat}
                                onChange={(e) => handleInputChange('meetingFormat', e.target.value)}
                                className={`form-input form-select ${errors.meetingFormat ? 'error' : ''}`}
                            >
                                <option value="">Select meeting type</option>
                                {meetingTypes.map(type => (
                                    <option key={type} value={type}>{type}</option>
                                ))}
                            </select>
                            {errors.meetingFormat && <p className="error-message">{errors.meetingFormat}</p>}
                        </div>

                        {/* Type of Meeting Label */}
                        <div className="form-group">
                            <label className="form-label">
                                Type of Meeting <span className="required">*</span>
                            </label>

                            {/* Select Dropdown */}
                            <select
                                value={formData.typeOfMeeting || ""}
                                onChange={(e) => handleInputChange("typeOfMeeting", e.target.value)}
                                className={`form-input ${errors.typeOfMeeting ? "error" : ""}`}
                            >
                                <option value="">-- Select --</option>
                                {typeofmetting.map((type) => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                            {errors.typeOfMeeting && <p className="error-message">{errors.typeOfMeeting}</p>}

                            {/* Conditional Input for Other */}
                            {formData.typeOfMeeting === "Other:" && (
                                <div className="form-group" style={{ marginTop: "0.5rem" }}>
                                    <label className="form-label">Please specify <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        value={formData.otherMeetingType || ""}
                                        onChange={(e) => handleInputChange("otherMeetingType", e.target.value)}
                                        className={`form-input ${errors.otherMeetingType ? "error" : ""}`}
                                        placeholder="Enter custom meeting type"
                                    />
                                    {errors.otherMeetingType && (
                                        <p className="error-message">{errors.otherMeetingType}</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );

            case 3:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Meeting Schedule Details</h2>
                            <p className="step-description">Enter date, start time, and whether the meeting goes beyond 4:00 pm. A 2nd interpreter is needed for meetings over 2.5 hours.</p>

                        </div>

                        {/* Meeting Date */}
                        <div className="form-group">
                            <label className="form-label">
                                Meeting Date <span className="required">*</span>
                            </label>
                            <div className="input-image">
                                <input
                                    type="date"
                                    value={formData.meetingDate}
                                    onChange={(e) => handleInputChange('meetingDate', e.target.value)}
                                    className={`${errors.meetingDate ? 'error' : ''}`}
                                />
                                <img src="/images/celender.png" alt="Calendar Icon" className="custom-icon" />
                            </div>
                            {errors.meetingDate && <p className="error-message">{errors.meetingDate}</p>}
                        </div>

                        {/* After Hours Meeting Start Time */}
                        <div className="form-group">
                            <label className="form-label">
                                After Hours Meeting Start Time <span className="required">*</span><br />
                                Reminder: If you are filling out this form, it's due to this meeting going past 4:00pm. <br />
                                (A 2nd Translator/interpreter is needed for meetings longer than 2.5 hours).
                            </label>
                            <div className="input-image">
                                <input
                                    type="time"
                                    value={formData.afterHoursStartTime}
                                    onChange={(e) => handleInputChange('afterHoursStartTime', e.target.value)}
                                    className={`${errors.afterHoursStartTime ? 'error' : ''}`}
                                />
                                <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                            </div>
                            {errors.afterHoursStartTime && <p className="error-message">{errors.afterHoursStartTime}</p>}
                        </div>

                        {/* Meeting End Time Select */}
                        <div className="form-group">
                            <label className="form-label">
                                Will this meeting/event end by 4:00 pm or sooner?
                            </label>
                            <select
                                value={formData.endsByFour || ""}
                                onChange={(e) => {
                                    handleInputChange("endsByFour", e.target.value);
                                    if (e.target.value === "Yes") {
                                        setShowSpecialStep(true);   // ✅ special step open karna
                                    } else {
                                        setShowSpecialStep(false);  // ✅ normal flow
                                    }
                                }}
                                className="form-input form-select"
                            >
                                <option value="">-- Select --</option>
                                <option value="Yes">Yes - it will end before 4:00 pm</option>
                                <option value="No">No - it will go beyond 4:00 pm</option>
                            </select>
                        </div>
                    </div>
                );

            case "specialStep":
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">
                                Meetings/events that will end before 4:00 pm need to utilize the link form below:
                            </h2>
                        </div>

                        <div className="form-group">
                            <Link
                                to="/interpreting-service-request/generate"
                                className="form-link"
                            >
                                Click here to fill out the interpreting service request form
                            </Link>
                        </div>
                    </div>
                );

            case 4:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">
                                Meeting Location & Contact Information
                            </h2>
                            <p className="step-description">Enter meeting end time, location, contacts, and instructions. Add student details if applicable.</p>

                        </div>

                        {/* After Hours Meeting End Time */}
                        <div className="form-group">
                            <label className="form-label">
                                After Hours Meeting End Time <span className="required">*</span> <br />
                                (Please give additional time for interpretation, especially on zoom)
                            </label>
                            <div className="input-image">
                                <input
                                    type="time"
                                    value={formData.afterHoursEndTime || ""}
                                    onChange={(e) =>
                                        handleInputChange("afterHoursEndTime", e.target.value)
                                    }
                                    className={`${errors.afterHoursEndTime ? "error" : ""}`}
                                />
                                <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                            </div>
                            {errors.afterHoursEndTime && (
                                <p className="error-message">{errors.afterHoursEndTime}</p>
                            )}
                        </div>
                        {/* Meeting Location Phone Number */}
                        <div className="form-group">
                            <label className="form-label">
                                Meeting Location Phone Number <span className="required">*</span>
                            </label>
                            <input
                                type="tel"
                                value={formData.meetingPhone || ""}
                                onChange={(e) => {
                                    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                    let formatted = digits;
                                    if (digits.length > 6) formatted = `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
                                    else if (digits.length > 3) formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
                                    handleInputChange("meetingPhone", formatted);
                                }}
                                className={`form-input ${errors.meetingPhone ? "error" : ""}`}
                                placeholder="xxx-xxx-xxxx"
                                maxLength={12}
                            />
                            {errors.meetingPhone && (
                                <p className="error-message">{errors.meetingPhone}</p>
                            )}
                        </div>

                        {/* Room Number or location at site */}
                        <div className="form-group">
                            <label className="form-label">
                                Room Number or location at site <br />
                                If available or applicable
                            </label>
                            <input
                                type="text"
                                value={formData.roomNumber || ""}
                                onChange={(e) => handleInputChange("roomNumber", e.target.value)}
                                className="form-input"
                                placeholder="Enter room number or location"
                            />
                        </div>

                        {/* Interpreter should report to whom */}
                        <div className="form-group">
                            <label className="form-label">
                                Interpreter should report to whom? <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.reportTo || ""}
                                onChange={(e) => handleInputChange("reportTo", e.target.value)}
                                className={`form-input ${errors.reportTo ? "error" : ""}`}
                                placeholder="Enter name or role (e.g., Ms. Johnson, Office Admin)"
                            />
                            {errors.reportTo && <p className="error-message">{errors.reportTo}</p>}
                        </div>

                        {/* Additional Contact Number */}
                        <div className="form-group">
                            <label className="form-label">
                                Additional Contact Number to be given to Interpreter
                            </label>
                            <input
                                type="tel"
                                value={formData.additionalContact || ""}
                                onChange={(e) => {
                                    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                    let formatted = digits;
                                    if (digits.length > 6) formatted = `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
                                    else if (digits.length > 3) formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
                                    handleInputChange("additionalContact", formatted);
                                }}
                                className="form-input"
                                placeholder="xxx-xxx-xxxx"
                                maxLength={12}
                            />
                        </div>

                        {/* Other related information */}
                        <div className="form-group">
                            <label className="form-label">
                                Other related information to share with the interpreter and LDO
                            </label>
                            <input
                                type="text"
                                value={formData.additionalInfo || ""}
                                onChange={(e) => handleInputChange("additionalInfo", e.target.value)}
                                className="form-input"
                                placeholder="Enter other information"
                            />
                        </div>

                        {/* Student Specific Meeting */}
                        <div className="form-group">
                            <label className="form-label">
                                Is the meeting specific to a student? (i.e. 504, IEP, SST, etc.)
                                <span className="required">*</span>
                            </label>
                            <select
                                value={formData.studentSpecific || ""}
                                onChange={(e) => handleInputChange("studentSpecific", e.target.value)}
                                className={`form-input form-select ${errors.studentSpecific ? "error" : ""
                                    }`}
                            >
                                <option value="">-- Select --</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                            {errors.studentSpecific && (
                                <p className="error-message">{errors.studentSpecific}</p>
                            )}
                        </div>
                    </div>
                );

            case 5:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Student & Guardian Information</h2>
                            <p className="step-description">Enter the student’s details and parent/guardian contact information. Please include the area code in phone numbers.</p>
                        </div>

                        {/* Student's Name */}
                        <div className="form-group">
                            <label className="form-label">
                                Student's Full Name <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.studentName || ""}
                                onChange={(e) => handleInputChange("studentName", e.target.value)}
                                className={`form-input ${errors.studentName ? "error" : ""}`}
                                placeholder="Enter student's full name"
                            />
                            {errors.studentName && <p className="error-message">{errors.studentName}</p>}
                        </div>

                        {/* Student's Perm ID Number */}
                        <div className="form-group">
                            <label className="form-label">
                                Student's 7 digit Perm ID Number <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.studentPermId || ""}
                                onChange={(e) => handleInputChange("studentPermId", e.target.value)}
                                className={`form-input ${errors.studentPermId ? "error" : ""}`}
                                placeholder="Enter student's ID number"
                            />
                            {errors.studentPermId && <p className="error-message">{errors.studentPermId}</p>}
                        </div>

                        {/* School Student Currently Attends */}
                        <div className="form-group">
                            <label className="form-label">
                                School Student Currently Attends <span className="required">*</span>
                            </label>
                            <select
                                value={formData.studentSchool || ""}
                                onChange={(e) => handleInputChange("studentSchool", e.target.value)}
                                className={`form-input form-select ${errors.studentSchool ? "error" : ""}`}
                            >
                                <option value="">-- Select School --</option>
                                {schools.map((school) => (
                                    <option key={school.id} value={school.id}>
                                        {school.name}
                                    </option>
                                ))}
                            </select>
                            {errors.studentSchool && <p className="error-message">{errors.studentSchool}</p>}
                        </div>

                        {/* Parent or Guardian's Full Name */}
                        <div className="form-group">
                            <label className="form-label">
                                Parent or Guardian's Full Name <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.guardianName || ""}
                                onChange={(e) => handleInputChange("guardianName", e.target.value)}
                                className={`form-input ${errors.guardianName ? "error" : ""}`}
                                placeholder="Enter parent's/guardian's full name"
                            />
                            {errors.guardianName && <p className="error-message">{errors.guardianName}</p>}
                        </div>

                        {/* Parent or Guardian's Phone Number */}
                        <div className="form-group">
                            <label className="form-label">
                                Parent or Guardian's Phone Number <span className="required">*</span><br />
                                ( NOTE: Translators don't make phone calls prior to meetings to confirm appointments for sites, unless arranged with the IEP team.) <br />
                                Please include area code (xxx-xxx-xxxx)
                            </label>
                            <input
                                type="tel"
                                value={formData.guardianPhone || ""}
                                onChange={(e) => {
                                    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                    let formatted = digits;
                                    if (digits.length > 6) formatted = `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
                                    else if (digits.length > 3) formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
                                    handleInputChange("guardianPhone", formatted);
                                }}
                                className={`form-input ${errors.guardianPhone ? "error" : ""}`}
                                placeholder="xxx-xxx-xxxx"
                                maxLength={12}
                            />
                            {errors.guardianPhone && <p className="error-message">{errors.guardianPhone}</p>}
                        </div>
                    </div>
                );
            case 6:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">"Language & Additional Details</h2>
                            <p className="step-description">Select service language and add details. LDO currently assesses Spanish/English for bilingual exams.</p>

                        </div>

                        {/* Language of Service */}
                        <div className="form-group">
                            <label className="form-label">
                                Select language of service <span className="required">*</span><br />
                                if you are booking a bilingual exam: we currently assess Spanish/English proficiency at LDO. We are working on having Online proctored exams for additional languages that may be available soon.
                            </label>
                            <select
                                value={formData.languageOfService || ""}
                                onChange={(e) => handleInputChange("languageOfService", e.target.value)}
                                className={`form-input form-select ${errors.languageOfService ? "error" : ""}`}
                            >
                                <option value="">-- Select Language --</option>
                                {languages.map((lang) => (
                                    <option key={lang.id} value={lang.id}>
                                        {lang.name}
                                    </option>
                                ))}
                            </select>
                            {errors.languageOfService && (
                                <p className="error-message">{errors.languageOfService}</p>
                            )}
                        </div>

                        {/* Dialect */}
                        <div className="form-group">
                            <label className="form-label">
                                Dialect (if applicable)
                            </label>
                            <input
                                type="text"
                                value={formData.dialect || ""}
                                onChange={(e) => handleInputChange("dialect", e.target.value)}
                                className="form-input"
                                placeholder="Enter dialect (optional)"
                            />
                        </div>

                        {/* Additional Comments */}
                        <div className="form-group">
                            <label className="form-label">
                                Any additional comments regarding your request?
                            </label>
                            <textarea
                                type="text"
                                value={formData.additionalComments || ""}
                                onChange={(e) => handleInputChange("additionalComments", e.target.value)}
                                className="form-input"
                                placeholder="Enter additional comments"
                            />
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="app-container">
            <div className="header">
                <div className="logo">
                    <div className="logo_wrapper">
                        <img src="/images/logo-fill.png" alt="ALGOVI Logo" className="logo-img" />
                    </div>
                </div>
                <h1 className="main-title">Interpreter Requests for Evening School Events </h1>
            </div>

            {/* Progress Steps */}
            {/* <div className="progress-container">
                <div className="progress-steps">
                    <div className="steps-wrapper">
                        {steps.map((step, index) => {
                            const Icon = step.icon;

                            // ✅ Agar step 8 pe hain to progress ko Step 2 tak hi count karo

                            const isActive = numericStep === step.id;
                            const isCompleted = numericStep > step.id;

                            return (
                                <div key={step.id} className="step">
                                    <div
                                        className={`step-icon ${isActive ? "active" : isCompleted ? "completed" : "inactive"
                                            }`}
                                    >
                                        <Icon size={20} />
                                    </div>
                                    <div
                                        className={`step-label ${isActive || isCompleted
                                            ? isActive
                                                ? "active"
                                                : "completed"
                                            : "inactive"
                                            }`}
                                    >
                                        {step.title}
                                    </div>
                                    {index < steps.length - 1 && (
                                        <div
                                            className={`step-connector ${isCompleted ? "completed" : "inactive"
                                                }`}
                                        />
                                    )}
                                </div>
                            );
                        })}

                    </div>
                </div>
            </div> */}

            <div className="form-container">
                <div className="form-card">
                    {renderStepContent()}

                    {/* Navigation Buttons */}
                    <div className="navigation">
                        <span className="step-indicator one">
                            Step {numericStep} of {steps.length}
                        </span>
                        <div className="navigation_inner">
                            <button
                                onClick={handlePrevious}
                                disabled={currentStep === 1}
                                className={`nav-button previous ${currentStep === 1 ? '' : 'secondary'
                                    }`}
                            >
                                <ChevronLeft size={20} style={{ marginRight: '0.5rem' }} />
                                Previous
                            </button>

                            <span className="step-indicator two">
                                Step {numericStep} of {steps.length}
                            </span>

                            {currentStep === "specialStep" ? (
                               <div style={{width: '110px'}}></div>
                            ) : currentStep < steps.length ? (
                                <button onClick={handleNext} className="nav-button primary">
                                    Next
                                    <ChevronRight size={20} style={{ marginLeft: "0.5rem" }} />
                                </button>
                            ) : (
                                <button onClick={handleSubmit} className="nav-button success">
                                    Submit Request
                                    <CheckCircle size={20} style={{ marginLeft: "0.5rem" }} />
                                </button>
                            )}
                        </div>
                    </div>


                </div>
            </div>
             <div className="copy_right" style={{ textAlign: 'center', margin: '2rem', fontSize: '15px', lineHeight: '1.5' }}>
                    <p>Copyright 2025 <a href="https://algovisolutions.com/">Algovi Services LLC.</a> All rights reserved</p>
            </div>                   
            {/* Add your CSS inside JSX or external stylesheet */}
            <style jsx>{`
                .form-select {
                padding-right: 40px !important;
                }
        .app-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(#6F8DFF, #57CCF3);
          padding: 1rem;
          flex-direction: column;
        }

        .form-container {
            max-width: 48rem;
                 margin: 0 auto;
        }
        .form-card {
             background: white;
             border-radius: 0.5rem;
             box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
             padding: 2rem;
             min-width: 660px;
        }
        .header {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 10px;
        }
        .main-title {
          font-size: 2.4rem;
          font-weight: bold;
          color: #ffffffff;
          margin-bottom: 3.4rem;
          line-height: 1.2;
          margin-bottom: 2rem;
          text-align: center;
        }
        .logo_wrapper{
           margin-bottom: 7px;
        }
        .logo_wrapper img{
           height: 80px;
        }
          .step-header {
          text-align: center;
          margin-bottom: 2rem;
        }
          .step-title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #1f2937;
          margin-bottom: 0.8rem;
        line-height: 1.3;
        text-align: start;
        }
        .form-group {
          margin-bottom: 1.5rem;
        }
        .progress-container {
          margin-bottom: 2rem;
          flex-grow: unset;
        }
          .step-description {
          color: #000000ff;
          line-height: 1.4;
          text-align: start;
        }
          .form-link{
          text-align: center;
          display: block;
          }
          .form-label {
          display: block;
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          margin-bottom: 0.5rem;
          line-height: 1.5;
        }
          .checkbox-group{
              display: flex;
              flex-direction: column;
          }
          .checkbox-group label{
                display: flex;
                align-items: center;
                font-size: 16px;
                margin-top: 15px;
          }
          .checkbox-group label:first-child{
                margin-top: 0;
            }
        input[type="checkbox"] {
             height: 16px;
             width: 16px;
             margin-right: 10px;
             flex-shrink: 0;
        }
           .form-input { 
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #d1d5db;
          border-radius: 0.5rem;
          font-size: 1rem;
          transition: all 0.2s ease;
          box-sizing: border-box;
        }
        select.form-input {
           appearance: none;      
           -webkit-appearance: none;   
           -moz-appearance: none; 
           background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0.75rem center;
        background-size: 1.8rem;
        }
        .form-input:focus {
          outline: none;
          border-color: transparent;
          box-shadow: 0 0 0 2px #6F8DFf;
        }

        .form-input.error {
          border-color: #ef4444;
        }
        .progress-steps {
          display: flex;
          justify-content: center;
        }
        .required {
          color: #ef4444;
        }
        .steps-wrapper {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .step {
          display: flex;
          align-items: center;
        }

        .step-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 50%;
          border: 2px solid;
          transition: all 0.3s ease;
        }

        .step-icon.active {
          background-color: #2563eb;
          border: none;
          color: white;
          box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -4px 0 0 #00000054;
        }

        .step-icon.completed {
          background-color: #10b981;
          border: none;
          color: white;
           box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -4px 0 0 #00000054;
        }

        .step-icon.inactive {
          background-color: white;
          border-color: #d1d5db;
          color: #9ca3af;
        }

        .step-label {
          margin-left: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .step-label.active,
        .step-label.completed {
          color: #1f2937;
        }

        .step-label.inactive {
          color: #9ca3af;
        }

        .step-connector {
          width: 2rem;
          height: 2px;
          margin: 0 1rem;
          transition: background-color 0.3s ease;
        }

        .step-connector.completed {
          background-color: #10b981;
          box-shadow: 1px 1px 2px 0px #00000059;
        }

        .step-connector.inactive {
          background-color: #d1d5db;
          box-shadow: 1px 1px 2px 0px #00000059;
        }

        .navigation{
            margin-top: 2rem;
            border-top: 1px solid #e5e7eb;
            padding-top: 1.5rem;
                
        }
        .navigation_inner {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .navigation .step-indicator.one{
           display: none;  
           text-align: center;
           margin-bottom: 13px;       
        }
        .nav-button {
          display: flex;
          align-items: center;
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          font-weight: 500;
          border: none;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 1rem;
        }

        .nav-button:disabled {
          background-color: #f3f4f6;
          color: #9ca3af;
          cursor: not-allowed;
        }

        .nav-button.primary {
          background-color: #6F8DFf;
          color: white;
            box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 2px 0 0 hsla(0, 0%, 100%, .25), inset 0 -3px 0 0 #4e6bdd;
        }

        .nav-button.primary:hover:not(:disabled) {
          background-color: #6785ffff;
        }
        .nav-button.primary:active:not(:disabled) {
            box-shadow: none;
        }
        .nav-button.secondary {
          background-color: #e5e7eb;
          color: #374151;
        }

        .nav-button.secondary:hover:not(:disabled) {
          background-color: #d1d5db;
        }

        .nav-button.success {
          background-color: #059669;
          color: white;
        }

        .loader_wrapper{
            height: 100vh;
            width: 100vw;
            background-color: #ffffffb2;
            position: fixed;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            }
            .loader_wrapper img{
                height: 70px;
                animation: loader .8s infinite linear;
        }
        @keyframes loader{
            from{
                transform: rotate(0deg);
            }
            to{
                transform: rotate(360deg);
            }
        } 

        .nav-button.success:hover:not(:disabled) {
          background-color: #047857;
        }

        .step-indicator {
          font-size: 0.875rem;
          color: #6b7280;
        }
           @media (max-width: 850px) {
           .form-card{
                min-width: 100%;
           }
           .main-title{
           font-size: 2.3rem;
           }
          .logo_wrapper img {
           height: 80px;
        }
           .logo-img {
           padding: 9px;
           }
        .logo_wrapper {
            margin-bottom: 0px;
        }
          .form-row {
            grid-template-columns: 1fr;
          }
          
          .steps-wrapper {
            gap: 0.1rem;
          }
          
          .step-label {
            display: none;
          }
          
          .step-connector {
            width: 1rem;
            margin: 0 0.5rem;
          }
        }
            @media (max-width: 650px) {
            select.form-input {
                background-size: 1.5rem !important;
            }
            .step-icon {
                width: 2.1rem;
                height: 2.1rem;
            }
            .step-icon svg{
                height: 15px;
            }
            .main-title {
                font-size: 1.8rem;
            }
            .step-title {
               font-size: 1.6rem;
            }
            .steps-wrapper {
               gap: 0;
            }
        }
             @media (max-width: 768px) {
          .summary-grid {
            grid-template-columns: 1fr;
          }
        }
           @media (max-width: 550px) {
                .nav-button.success{
                    width: min-content;
                }
           }
            @media (max-width: 470px) {
            .step-icon.active{
                box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -3px 0 0 #00000054;
            }
            .step-icon.completed {
                box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -3px 0 0 #00000054;

            }
            .logo_wrapper img {
                height: 65px;
            }
            .main-title {
                font-size: 1.8rem;
                margin-bottom: 1.9rem;
            }    
            .step-icon svg {
                height: 12px;
            }
            .step-icon {
                width: 1.7rem;
                height: 1.7rem;
            }
            .step-connector {
                margin: 0 0.3rem;
            }
            .nav-button {
                font-size: 0.9rem;
                padding: 0.65rem 1.1rem;
            }
            .nav-button.primary svg{
                margin-left: 0.1rem !important;
            }
            .nav-button.previous svg{
                margin-right: 0.1rem !important;
            }
            .form-card {
                padding: 1.2rem;
            }
            .form-input {
                font-size: 0.95rem;
            }
            step-description{
                font-size; 15px;
            }
                    .step-title {
        font-size: 1.4rem;
    }
            .step-description {
        font-size: 15px;
    }
        }
        @media (max-width: 550px) {
            .navigation .step-indicator.one{
                display: block;
            }
            .navigation_inner .step-indicator.two{
                display: none;
            }
            .navigation {
                padding-top: 1rem;
                }
                }
              
      `}</style>
      {loading && (
      <div className="loader_wrapper">
        <img src="/images/form_loader.svg" alt="" />
      </div>
    )}
        </div>
    );
};

export default InterpretingForm2;
